define(['jquery'], function($) {
	var Utilities = {};


	/**
	 * naformatuje vstup (integer number) jako string s oddelenymi rady
	 * @param input
	 * @return {String}
	 */
	Utilities.formatInteger = function (input) {
		input = input.toString();
		return input.replace(/((?=(\d{7,9}))((\d{0,3})(\d{3})(\d{3}))|((\d{0,3})(\d{3})))$/g, '$4 $5 $6 $8 $9').replace(/(^\s*)|(\s*$)/g, '');
	};

	/**
	 * naformatuje vstup (float number) jako string s oddelenymi rady
	 * @param input
	 * @return {String}
	 */
	Utilities.formatFloat = function (input) {
		var inputSplit = input.toString().replace(',', '.').split('.'),
				postfix;

		if (inputSplit.length == 1) {
			postfix = '';
		}
		else {
			if (typeof web.lang != undefined && web.lang == 'cs') {
				postfix = ',' + inputSplit[1];
			}
			else {
				postfix = '.' + inputSplit[1];
			}
		}

		return formatInteger(inputSplit[0]) + postfix;
	};

	/**
	 * nafomatuje vstup (desetinne cislo) jako string dle lokalnich zvyklosti
	 * @param input
	 * @return {*}
	 */
	Utilities.formatDecimalNumber = function (input) {
		input = input.toString();
		if (typeof web.lang != undefined && web.lang == 'cs') {
			input = input.replace('.', ',');
		}
		return input;
	};

	/**
	 * zaokrouhli cislo number na dany pocet desetinnych mist
	 * @param number
	 * @param precision
	 * @return {Number}
	 */
	Utilities.round = function (number, precision) {
		var val = precision != undefined ? Math.pow(10, precision) : 1;
		return Math.round(number * val) / val;
	};

	/**
	 * zaoukrouhli cislo dle radu daneho parametrem accuracy (10=desitky,100=stovky...)
	 * @param number
	 * @param accuracy
	 * @return {Number}
	 */
	Utilities.roundAccuracy = function (number, accuracy) {
		return Math.round(number / accuracy) * accuracy
	};

	Utilities.ceilAccuracy = function (number, accuracy) {
		return Math.ceil(number / accuracy) * accuracy
	};

	/**
	 * Polyfill isInteger
	 * @type {any}
	 */
	Number.prototype.isInteger = Number.isInteger || function () {
				var value = this;
				return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
			};

	/**
	 * loads params from url
	 * @return {Array} associative array with params and values
	 */
	Utilities.parseUrlParams = function () {
		var vars = [],
				hash,
				hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	};

	/**
	 * sanitize value due valueType
	 * @param value
	 * @param valueType
	 * @return {*}
	 */
	Utilities.sanitize = function (value, valueType) {
		var result;

		// sanitize for integer
		if (valueType == 'integer') {
			result = parseInt(value);
		}
		// sanitize for float
		else if (valueType == 'float') {
			result = parseFloat(value.toString().replace(',', '.'));
		}

		if (isNaN(result)) {
			result = '';
		}
		return result;
	};

	/**
	 * funkce doplni string hodnotu value o nuly, tak aby pocet znaku odpovidal hodnote size
	 * @param value
	 * @param size
	 * @return {*}
	 */
	Utilities.stringPad = function (value, size) {
		while (value.length < size) value = '0' + value;
		return value;
	};

	/**
	 * funkce odstrani z hodnoty value mezery, nuly a znamenko ze zacatku retezce
	 * @param value
	 * @return {String}
	 */
	Utilities.trimZeros = function (value) {
		var result = '',
				subValue = '';

		for (var i = 0; i <= value.length; i++) {
			subValue = value.substr(i, 1);

			if (!((subValue == ' ') || (subValue == '0') || (subValue == '-') || (subValue == '+'))) {
				result = value.substr(i);
				break;
			}
		}
		return result;
	};


	/**
	 * Projde pole array, jehoz hodnoty jsou ve formatu parameter=value, nalezne dany parameter a vrati jeho value
	 * @param parameter Nazev hledaneho parametru
	 * @param array Pole
	 * @return {*}
	 */
	Utilities.getParameterValue = function (parameter, array) {
		var result = null;

		for (var i in array) {
			if (array[i].indexOf(parameter + '=') != -1) {
				result = array[i].split('=')[1];
			}
		}

		return result;
	};


	/**
	 * funkce odstrani diakritiku ze string retezce
	 * @return {*}
	 */
	String.prototype.removeDiacritic = function () {
		var sdiak = new Array(/[áäàâãå]/g, /[čćĉ]/g, /[ď]/g, /[éěèêë]/g, /[íìîï]/g, /[ĺľ]/g, /[ňñ]/g, /[óòôö]/g, /[ŕř]/g, /[šśŝ]/g, /[ť]/g, /[úůüùûű]/g, /[ýÿŷ]/g, /[ž]/g, /[ÁÄÀÂÃÅ]/g, /[ČĆĈ]/g, /[Ď]/g, /[ÉĚÈÊË]/g, /[ÍÌÎÏ]/g, /[ĹĽ]/g, /[ŇÑ]/g, /[ÓÒÔÖ]/g, /[ŔŘ]/g, /[ŠŚŜ]/g, /[Ť]/g, /[ÚŮÜÙÛŰ]/g, /[ÝŶŸ]/g, /[Ž]/g);
		var bdiak = new Array("a", "c", "d", "e", "i", "l", "n", "o", "r", "s", "t", "u", "y", "z", "A", "C", "D", "E", "I", "L", "N", "O", "R", "S", "T", "U", "Y", "Z");
		var str = this;
		for (var i = 0; i < sdiak.length; i++) {
			str = str.replace((sdiak[i]), bdiak[i]);
		}
		return str;
	};


	Utilities.getObjectLength = function (object) {
		var count = 0;

		for (var i in object) {
			if (object.hasOwnProperty(i)) {
				count++;
			}
		}
		return count;
	};

	return Utilities;
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/utilities.js